<template>
    <el-row>
      <el-col :span="24">
        <div class>
      <div class="center">
        <div class="top">
            <img src="../../../assets/library/chengguo/组 25082@2x.png" alt />
            </div>
            <div class="middle">
                <img src="../../../assets/library/chengguo/组 24938@2x.png" alt />
            </div>
      </div>
      <div class="bottom">
        <img src="../../../assets/library/chengguo/组 25083@2x.png" alt />
        </div>
        </div>
      </el-col>
    </el-row>
  </template>
  
  <script>

 
  export default {
   
  }
  </script>
  
  <style lang="scss" scoped>
 .center{
    width:70rem;
    height: 98rem;
    margin-left: 25rem;
    .top{
        margin-top: 2rem;
        width: 70rem;
        height: 42rem;
        img{
            width: 100%;
        height: 100%;
        }
    }
    .middle{
        width: 40rem;
        height: 50rem;
        margin-top: 3rem;
        margin-left: 15rem;
        img{
            width: 100%;
        height: 100%;
        }
    }
 }
 .bottom{
    width:100%;
        height: 50rem;
    img{
        width: 100%;
        height: 100%;
    }
 }
  </style>